import React from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {FormControl, FormLabel} from "@mui/material";
import style from "../../assets/css/global-fields.module.scss";
import dayjs from "dayjs";
import {MobileDatePicker} from "@mui/x-date-pickers";
import {isMobile} from "react-device-detect";
import {Refresh} from "@mui/icons-material";

const GlobalYearField = ({
  id,
  name,
  title,
  onChange,
  onBlur,
  value = null,
  minDateValue = null,
  maxYearsAgo = 5, // Default to 5 years in the past
  disablePast = false,
  error = false,
  helperText,
  disabled = false,
  clearBtn = false,
  placeH = "Select Year",
}) => {
  // Set the min year (maxYearsAgo years ago)
  const currentYear = dayjs();
  const minYear = currentYear.subtract(maxYearsAgo, "year");

  return (
    <div className={style.proposalDateField}>
      <FormControl
        fullWidth
        className="GDateField"
        style={{position: "relative"}}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* <FormLabel htmlFor={id}>{title}</FormLabel> */}
          <FormLabel
            htmlFor={id}
            sx={{
              position: "absolute",
              width: 1,
              height: 1,
              padding: 0,
              margin: "-1px",
              overflow: "hidden",
              clip: "rect(0,0,0,0)",
              border: 0,
            }}
          >
            {title || "Select date"}
          </FormLabel>
          {isMobile ? (
            <MobileDatePicker
              views={["year"]}
              minDate={minYear}
              maxDate={currentYear}
              openTo="year"
              id={id}
              value={value ? dayjs(value) : null}
              onChange={(newValue) => {
                if (onChange) {
                  onChange(newValue, name); // Pass selected value and field name
                }
              }}
              readOnly={disabled}
              slotProps={{
                textField: {
                  error: error,
                  helperText: helperText || "",
                  InputProps: {
                    readOnly: true,
                  },
                  inputProps: {
                    placeholder: placeH, // ✅ Explicit placeholder
                    readOnly: true,
                    "aria-label": title || "Select Year", // ← Add aria-label here
                  },
                },
              }}
            />
          ) : (
            <DatePicker
              views={["year"]}
              openTo="year"
              minDate={minYear}
              maxDate={currentYear}
              id={id}
              value={value ? dayjs(value) : null}
              onChange={(newValue) => {
                if (onChange) {
                  onChange(newValue, name); // Pass selected value and field name
                }
              }}
              slotProps={{
                textField: {
                  size: "small",
                  error: error,
                  helperText: helperText || "",
                  disabled: disabled,
                  onBlur: () => {
                    if (onBlur) {
                      onBlur({target: {name}});
                    }
                  },
                  InputProps: {
                    readOnly: true,
                  },
                  inputProps: {
                    placeholder: placeH, // ✅ Needed to ensure placeholder shows
                    readOnly: true,
                    "aria-label": title || "Select Year", // ← Add aria-label here
                  },
                },
              }}
            />
          )}
          {clearBtn ? (
            <div className={style.clearDateBtn}>
              <Refresh onClick={() => onChange("", name)} />
            </div>
          ) : null}
        </LocalizationProvider>
      </FormControl>
    </div>
  );
};

export default GlobalYearField;
